import React from 'react';

const LoadingIndicator = ({ isLoading, count }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="absolute bottom-[120px] left-1/2 -translate-x-1/2 z-[1000] w-10/12 bg-white/90 py-3 px-6 rounded-full shadow-lg flex items-center justify-center text-blue-500 border border-blue-500">
      <div className="flex items-center">
        <div className="w-5 h-5 rounded-full border-4 border-blue-500/20 border-l-blue-500 animate-spin"></div>
        <p className="ml-2.5">กำลังโหลด... ({count} รายการ)</p>
      </div>
    </div>
  );
};

export default LoadingIndicator;
